import PayPalCard from './paypal';
import StripeCard from './stripe';


export const supportedPaymentMethods = [
    {name: "paypal", props: ["client_id"],  component: PayPalCard},
    {name: "stripe", props: ["secret_key"],  component: StripeCard}
]